import React, { useState } from 'react';
import CalcShell from '../CalcShell';

export default function ModuloCalc() {
  const [a, setA] = useState(17);
  const [b, setB] = useState(5);
  const [showWork, setShowWork] = useState(false);
  const q = b !== 0 ? Math.trunc(a / b) : NaN;
  const r = b !== 0 ? a - q * b : NaN;
  const rPos = b !== 0 ? ((a % b) + b) % b : NaN;
  return (
    <CalcShell look="cnet" title="Modulo Calculator" subtitle="Compute the modulo (remainder) of the division of two integers.">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div>
          <div className="field"><label>a (dividend)</label><input type="number" value={a} onChange={e => setA(+e.target.value || 0)} data-testid="mod-a" /></div>
          <div className="field"><label>b (divisor / modulus)</label><input type="number" value={b} onChange={e => setB(+e.target.value || 0)} data-testid="mod-b" /></div>
        </div>
        <div>
          {b === 0 ? (
            <div className="text-red-600 font-medium">Division by zero — modulus b must be non-zero.</div>
          ) : (
            <div className="result-panel">
              <div className="result-title">{a} mod {b}</div>
              <div className="result-value" data-testid="mod-result">{r}</div>
              <table className="data-table mt-3"><tbody>
                <tr><td>Quotient q = ⌊a / b⌋</td><td className="text-right font-mono">{q}</td></tr>
                <tr><td>Remainder r = a − q·b</td><td className="text-right font-mono">{r}</td></tr>
                <tr><td>Positive remainder (a mod b, always ≥ 0)</td><td className="text-right font-mono">{rPos}</td></tr>
              </tbody></table>
            </div>
          )}
        </div>
      </div>
      <div className="mt-4">
        <button onClick={() => setShowWork(v => !v)} data-testid="mod-show-work-toggle"
          className="text-sm px-4 py-1.5 rounded bg-slate-200 hover:bg-slate-300 text-slate-800 font-medium">
          {showWork ? '− Hide working' : '+ Show working'}
        </button>
        {showWork && b !== 0 && (
          <div className="mt-4 p-5 bg-blue-50 border border-blue-100 rounded-xl" data-testid="mod-work-panel">
            <h3 className="text-lg font-bold text-slate-900 mb-3">Step-by-step working</h3>
            <ol className="list-decimal ml-5 space-y-2 text-slate-800 text-[15px] leading-7">
              <li><b>Definition</b>: For integers a and b (b ≠ 0), the quotient q and remainder r satisfy <span className="font-mono">a = q · b + r</span> with 0 ≤ r &lt; |b|.</li>
              <li><b>Truncated division</b>: <span className="font-mono">q = ⌊a / b⌋ = ⌊{a} / {b}⌋ = {q}</span></li>
              <li><b>Compute remainder</b>: <span className="font-mono">r = a − q · b = {a} − ({q}) · ({b}) = <b className="text-[#4c7b25]">{r}</b></span></li>
              <li><b>Verify</b>: <span className="font-mono">{q} × {b} + {r} = {q * b + r} = a</span> ✓</li>
              {r !== rPos && <li><b>Note</b>: Some contexts require a non-negative remainder. In that case <span className="font-mono">((a mod b) + |b|) mod |b| = {rPos}</span>.</li>}
            </ol>
          </div>
        )}
      </div>
    </CalcShell>
  );
}
